/* eslint-disable */
function swapEdgeImages() {
	if (document.getElementById('app').classList.contains('msEdge')) {
		const images = this.$el.getElementsByTagName('img');
		for (let i = 0; i < images.length; i += 1 ) {
			const imgSrc = images[i].src;
			const fileName = imgSrc.substring(imgSrc.lastIndexOf("/") + 1);
			console.log(fileName);
			if(fileName.substring(0,3) !== "ms_"){
				const newImgSrc = imgSrc.replace(/\/([^\/]*)$/, '/ms_' + '$1'); //a_b!c
				console.log(newImgSrc);
				images[i].src = newImgSrc;	
			}
		}
	}
}

export { swapEdgeImages };

export default {
	methods: {
		swapEdgeImages,
	},
};



// WEBPACK FOOTER //
// ./src/mixins/msEdgeImageSwap.js